import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { memo, useContext } from "react";
import ErrorIcon from "@mui/icons-material/Error";
import { Context } from "./Context";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ExceptionCell = memo(
  ({ params, setAddOpenPaycode, setAction, setCell }) => {
    const { t } = useTranslation("timecard.table");

    const regex = /auto-generated-row-null/;

    const { apiRef, periods, range1 } = useContext(Context);

    const gettingOpacity = () => {
      const period = periods.find(
        (period) => period.full_name === params?.rowNode?.groupingKey,
      );

      if (period) {
        if (
          moment(period.end_date, "YYYY-MM-DD").isSameOrAfter(
            moment(range1[1], "YYYY-MM-DD"),
          )
        ) {
          return 0.5;
        } else {
          return 1;
        }
      } else {
        return 1;
      }
    };

    const rows = params?.rowNode?.children
      ? params?.rowNode?.children?.map((id) => apiRef.current.getRow(id))
      : [];

    const totals = rows.reduce((acc, row) => {
      return acc + row?.exceptions.length;
    }, 0);

    const gettingText = (exception) => {
      switch (exception.type) {
        case "LATE":
          if (exception.in_punch_flag === true) {
            return t(`table.cells.${exception.type}.START`);
          } else {
            return t(`table.cells.${exception.type}.END`);
          }
        case "EARLY":
          if (exception.in_punch_flag === true) {
            return t(`table.cells.${exception.type}.START`);
          } else {
            return t(`table.cells.${exception.type}.END`);
          }
        case "VERY_EARLY":
          if (exception.in_punch_flag === true) {
            return t(`table.cells.${exception.type}`, {
              flag: t("table.cells.IN"),
            });
          } else {
            return t(`table.cells.${exception.type}`, {
              flag: t("table.cells.OUT"),
            });
          }
        case "VERY_LATE":
          if (exception.in_punch_flag === true) {
            return t(`table.cells.${exception.type}`, {
              flag: t("table.cells.IN"),
            });
          } else {
            return t(`table.cells.${exception.type}`, {
              flag: t("table.cells.OUT"),
            });
          }
        default:
          return t(`table.cells.${exception.type}`);
      }
    };

    return (
      <>
        <Box
          sx={{
            width: "100%",
            display: "grid",
            placeItems: "center",
            alignItems: "center",
            alignContent: "center",
            gap: "10px",
            p: 1.5,
          }}
        >
          {regex.test(params?.id) ? (
            <Box sx={{ opacity: gettingOpacity() }}>
              {totals > 0 ? (
                <Box sx={{ color: (theme) => theme.palette.error.main }}>
                  {totals}
                </Box>
              ) : (
                totals
              )}
            </Box>
          ) : (
            <>
              <List sx={{ width: "100%" }} dense={true}>
                {params?.value?.map((exception, index) => (
                  <ListItemButton
                    disabled={params?.row?.open_period.open === false}
                    sx={{
                      borderRadius: 5,
                    }}
                    key={`exception-${index}-${exception.total_span_index}-${exception.type}`}
                    onMouseOver={() => {
                      if (
                        params.row.punch_in.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === true,
                        )
                      ) {
                        params.row.punch_in.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === true,
                        ).hover = true;
                        apiRef.current.updateRows([params?.row]);
                      }

                      if (
                        params.row.punch_out.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === false,
                        )
                      ) {
                        params.row.punch_out.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === false,
                        ).hover = true;
                        apiRef.current.updateRows([params?.row]);
                      }
                    }}
                    onMouseOut={() => {
                      if (
                        params.row.punch_in.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === true,
                        )
                      ) {
                        params.row.punch_in.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === true,
                        ).hover = false;
                        apiRef.current.updateRows([params?.row]);
                      }

                      if (
                        params.row.punch_out.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === false,
                        )
                      ) {
                        params.row.punch_out.find(
                          (punch) =>
                            exception.total_span_index ===
                              punch.total_span_index &&
                            exception.in_punch_flag === false,
                        ).hover = false;
                        apiRef.current.updateRows([params?.row]);
                      }
                    }}
                    onClick={() => {
                      // console.log('params', params)
                      setAddOpenPaycode(true);
                      setAction("exception");
                      setCell({
                        column: undefined,
                        row: params?.row?.date,
                        employee_id: params?.row?.person_number,
                      });
                    }}
                  >
                    <ListItemIcon>
                      <ErrorIcon
                        color={exception.hover ? "error" : undefined}
                      />
                    </ListItemIcon>

                    <ListItemText
                      sx={{
                        ml: -2,
                        width: 130,
                        color: (theme) =>
                          exception.hover
                            ? theme.palette.error.main
                            : undefined,
                      }}
                      primary={
                        <Box
                          sx={{
                            overflowX: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {gettingText(exception)}
                        </Box>
                      }
                    />
                  </ListItemButton>
                ))}
              </List>
            </>
          )}
        </Box>
      </>
    );
  },
);

export { ExceptionCell };
